module.exports = __webpack_public_path__ + "static/media/cassidy.e5750857.png";